const ONLY_COLLAPSIBLE_WHITESPACE_REGEXP = /^[ \t\n\r\f]*$/;

export function isOnlyCollapsibleWhitespace(text: string): boolean {
  return ONLY_COLLAPSIBLE_WHITESPACE_REGEXP.test(text);
}

const COLLAPSIBLE_WHITESPACE_REGEXP = /[ \t\n\r\f]+/g;
const LEADING_OR_TRAILING_SPACES = /(^[ ]+|[ ]+$)/g;

export function collapseWhitespace(text: string): string {
  return text.replace(COLLAPSIBLE_WHITESPACE_REGEXP, ' ').replace(LEADING_OR_TRAILING_SPACES, '');
}

export function collapseInlineWhitespace(text: string): string {
  return text.replace(COLLAPSIBLE_WHITESPACE_REGEXP, ' ');
}

const NBSP_REGEXP = /\u00A0/g;
const ZWSP_REGEXP = /\u200B/g;

export function normalizeContentEditableWhitespace(text: string): string {
  return text.replace(NBSP_REGEXP, ' ').replace(ZWSP_REGEXP, '');
}

const WHITESPACE_REGEXP = /[ \t\n\r\f]|(&nbsp;)/g;
export function getCountOfWhiteSpace(text: string): number {
  return text.match(WHITESPACE_REGEXP)?.length ?? 0;
}

const ENDS_WITH_NEW_LINE_REGEXP = /\n$/g;
export function replaceEndingNewLine(text: string): string {
  return text.replace(ENDS_WITH_NEW_LINE_REGEXP, '');
}
